import { AuditoriaCaixaComponent } from "./../auditoria-caixa/auditoria-caixa.component";
import { ExibirConteudoCaixaComponent } from "./../exibir-conteudo-caixa/exibir-conteudo-caixa.component";
import { DialogConfirmComponent } from "./../../dialog/dialog-confirm/dialog-confirm.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { ClienteService } from "app/service/cliente/cliente.service";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import {
  FormControl,
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Component, OnInit, ViewChild } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { connect } from "net";
import * as JSPM from "jsprintmanager";

export class Atributo {
  operador: Operador[];
  descricao: String;
  valor: String;
  tipo: String;
}
export class Operador {
  operador: String;
  value: String;
}
@Component({
  selector: "app-pesquisa-caixa-avancada",
  templateUrl: "./pesquisa-caixa-avancada.component.html",
  styleUrls: ["./pesquisa-caixa-avancada.component.scss"],
})
export class PesquisaCaixaAvancadaComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  caixas: any[] = [];
  displayedColumns = [
    "select",
    "rgCaixa",
    "numeroCaixa",
    "areaCodigo",
    "descricaoArea",
    "codAlternativo",
    "descricaoTipoCaixa",
    "descricaoConteudoCaixa",
    "statusCaixa",
    "qtdItens",
    "dataAbertura",
    "alocacao",
    "acoes",
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  public clientes: ClienteModel[];
  queryField = new FormControl();
  public inputPesquisa = false;
  selectedPrinter: any;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public loading = false;
  isDefaultPrinterSelected = false;
  public etiquetas;
  printers: string[];
  idCaixa;
  clientePesquisado;
  pesquisaForm: FormGroup;
  pesquisaFormArray: FormArray;
  submit = false;
  deData;
  clienteId;
  disabled = ["string"];
  idCaixas: any[] = [];
  buttonRelatorio = true;
  adm = false;
  acervo = true;
  solicitacao = false;

  operadorGeral: Operador[] = [
    { operador: "igual", value: "igual" },
    { operador: "contenha", value: "contenha" },
    { operador: "comece com", value: "comeceCom" },
    { operador: "termine com", value: "termineCom" },
  ];

  operadorIgual: Operador[] = [{ operador: "igual", value: "igual" }];

  status = new Array<Atributo>();

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {
    let dataAbertura = new Atributo();
    dataAbertura.descricao = "Data Abertura";
    dataAbertura.valor = "dataAbertura";
    dataAbertura.operador = this.operadorGeral;
    dataAbertura.tipo = "string";

    let descricaoConteudo = new Atributo();
    descricaoConteudo.descricao = "Descrição do Conteúdo";
    descricaoConteudo.valor = "descricaoConteudo";
    descricaoConteudo.operador = this.operadorGeral;
    descricaoConteudo.tipo = "string";

    let tipoCaixa = new Atributo();
    tipoCaixa.descricao = "Tipo de Caixa";
    tipoCaixa.valor = "tpCaixa";
    tipoCaixa.operador = this.operadorGeral;
    tipoCaixa.tipo = "string";

    let statusRgCaixa = new Atributo();
    statusRgCaixa.descricao = "RG Caixa";
    statusRgCaixa.valor = "rgCaixa";
    statusRgCaixa.operador = this.operadorGeral;
    statusRgCaixa.tipo = "string";

    let statusCaixa = new Atributo();
    statusCaixa.descricao = "Status";
    statusCaixa.valor = "status";
    statusCaixa.operador = this.operadorIgual;
    statusCaixa.tipo = "igualdade";

    let nrCaixa = new Atributo();
    nrCaixa.descricao = "Nr. Caixa";
    nrCaixa.valor = "nrCaixa";
    nrCaixa.operador = this.operadorGeral;
    nrCaixa.tipo = "string";

    let codAlternativo = new Atributo();
    codAlternativo.descricao = "Cód. Alternativo";
    codAlternativo.valor = "codAlt";
    codAlternativo.operador = this.operadorGeral;
    codAlternativo.tipo = "string";

    let codArea = new Atributo();
    codArea.descricao = "Cód. Área";
    codArea.valor = "codArea";
    codArea.operador = this.operadorGeral;
    codArea.tipo = "string";

    let area = new Atributo();
    area.descricao = "Área";
    area.valor = "area";
    area.operador = this.operadorGeral;
    area.tipo = "string";

    let qtdItens = new Atributo();
    qtdItens.descricao = "Qtd. Itens";
    qtdItens.valor = "qtdItens";
    qtdItens.operador = this.operadorGeral;
    qtdItens.tipo = "string";

    this.status.push(
      statusRgCaixa,
      nrCaixa,
      codArea,
      area,
      codAlternativo,
      tipoCaixa,
      descricaoConteudo,
      statusCaixa,
      qtdItens,
      dataAbertura
    );

    iconRegistry.addSvgIcon(
      "addItens",
      sanitizer.bypassSecurityTrustResourceUrl(
        "../../../../assets/images/file-earmark-diff.svg"
      )
    );
    this.route.params.subscribe((params) => (this.clienteId = params["id"]));
    this.deData = CryptoJS.AES.decrypt(
      decodeURIComponent(this.clienteId),
      "pcdoc"
    );
    this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.listarClientesUsuario();

    this.pesquisaForm = this.formBuilder.group({
      pesquisaFormArray: this.formBuilder.array([this.createItem()]),
    });
    /*
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    JSPM.JSPrintManager.WS.onStatusChanged = () => {
        if (this.jspmWSStatus()) {
            // get client installed printers
            JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
              this.printers = myPrinters;
              console.log(this.printers);
              this.selectedPrinter = this.printers[2];
            });
        }
    }; */
  }

  onSubmit() {
    this.submit = true;
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = true;
        this.idCaixas.push(this.dataSource.data[i]["id"]);
        this.buttonRelatorio = false;
      }
    } else {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = false;
        var id = this.dataSource.data[i]["id"];
        let index = this.idCaixas.indexOf(id);
        this.idCaixas.splice(index, 1);
        this.buttonRelatorio = true;
      }
    }
  }

  imprimirEtiquetas() {
    if (this.idCaixas.length === 0) {
      this.openSnackBarError("Nenhuma caixa selecionada !");
    } else {
      this.caixaService.downloadEtiquetas(this.idCaixas).subscribe(
        (data) => {
          this.etiquetas = data;
          // this.doPrintZPL(data);
          this.download(data);
        },
        (err) => {
          console.error(err);
          this.openSnackBarError(
            "Selecione apenas caixas com endereço definido !"
          );
        }
      );
    }
  }

  download(text) {
    var date = new Date();
    var dateFormat = date.toLocaleDateString("pt-BR");
    var nameFile = "etiquetas_rgs_" + dateFormat + ".txt";
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", nameFile);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    this.idCaixas = [];
  }

  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      //alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      alert("JSPM has blocked this website!");
      return false;
    }
  }

  doPrintZPL(text) {
    if (this.jspmWSStatus()) {
      // Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();
      // Set Printer type (Refer to the help, there many of them!)
      //https://www.neodynamic.com/Products/Help/JSPrintManager4.0/articles/jsprintmanager.html#client-printer-types
      if (this.isDefaultPrinterSelected) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      // Set content to print...
      //Create Zebra ZPL commands for sample label
      var cmds = text;
      cpj.printerCommands = cmds;
      // Send print job to printer!
      cpj.sendToClient();
    }
  }

  checkIndividual(checked, idCaixa) {
    if (checked === true) {
      this.idCaixas.push(idCaixa);
    } else {
      let index = this.idCaixas.indexOf(idCaixa);
      this.idCaixas.splice(index, 1);
    }
    if (this.idCaixas.length > 0) {
      this.buttonRelatorio = false;
    } else {
      this.buttonRelatorio = true;
    }
  }

  onChange(e, indice) {
    this.desabilitarOperador(indice);
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      atributo: ["", [Validators.required]],
      operador: ["", Validators.required],
      conteudo: ["", [Validators.required]],
    });
  }

  desabilitarOperador(indice) {
    const group = this.pesquisaForm.get("pesquisaFormArray").value[indice];
    const arrayGroup = ["codArea", "qtdItens"];
    if (arrayGroup.includes(group.atributo)) {
      this.disabled[indice] = "number";
    } else if (group.atributo === "status") {
      this.disabled[indice] = "enum";
    } else if (group.atributo === "dataAbertura") {
      this.disabled[indice] = "date";
    } else {
      this.disabled[indice] = "string";
    }
  }

  createItemStatus(): FormGroup {
    return this.formBuilder.group({
      atributo: ["", [Validators.required]],
      operador: ["igual", Validators.required],
      conteudo: ["", [Validators.required]],
    });
  }

  addItem() {
    this.disabled.push("string");
    this.pesquisaFormArray = this.pesquisaForm.get(
      "pesquisaFormArray"
    ) as FormArray;
    this.pesquisaFormArray.push(this.createItem());
  }

  remover(indice: any) {
    if (indice > 0) {
      this.pesquisaFormArray.removeAt(indice);
      this.disabled.splice(indice, 1);
    } else {
      this.openSnackBarError(
        "Erro ao remover. O primeiro filtro é obrigatório !"
      );
    }
  }

  pesquisar() {
    this.loading = true;
    const arrayPesquisa = this.pesquisaForm.get("pesquisaFormArray").value;
    this.caixaService.pesquisaAvancada(this.clienteId, arrayPesquisa).subscribe(
      (data) => {
        if (data.length === 0) {
          this.loading = false;
          this.openSnackBarError("Nenhum resultado encontrado !");
        }
        data = data.map((value) => {
          value.isSelected = false;
          return value;
        });
        this.loading = false;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.loading = false;
        this.openSnackBarError("Erro ao tentar realizar a busca.");
      }
    );
  }

  exibirConteudos(caixaId: number) {
    const dialogRef = this.dialog.open(ExibirConteudoCaixaComponent, {
      width: "100%",
      data: { caixaId: caixaId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  relatorioCaixas() {
    if (this.idCaixas.length === 0) {
      this.openSnackBarError("Nenhuma caixa selecionada !");
    } else {
      const arrayIds = encodeURIComponent(
        CryptoJS.AES.encrypt(JSON.stringify(this.idCaixas), "pcdoc").toString()
      );
      window.open(
        `relatorio-caixas/${arrayIds}/${this.clienteId}`,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      ); // Open new window
    }
  }

  auditoriaCaixa(caixaId, rgCaixa) {
    const dialogRef = this.dialog.open(AuditoriaCaixaComponent, {
      width: "70%",
      data: { caixaId: caixaId, rgCaixa: rgCaixa },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  relatorioCaixa(caixaId) {
    const caixaIdRecebido = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    window.open(
      `relatorio-caixa/${caixaIdRecebido}`,
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    ); // Open new window
  }

  limpar() {
    this.submit = false;
  }

  fecharCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.fechaCaixaFunction(caixaId);
      }
    });
  }

  fechaCaixaFunction(idCaixa) {
    this.caixaService.fecharCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa fechada com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar fechar a caixa !");
        console.log(err);
      }
    );
  }

  abrirCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja abrir esta caixa ? Obs: Isso permitirá incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.abrirCaixaFunction(caixaId);
      }
    });
  }

  abrirCaixaFunction(idCaixa) {
    this.caixaService.abrirCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa aberta com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar abrir a caixa !");
        console.log(err);
      }
    );
  }

  onSearch() {
    let value = (<HTMLSelectElement>document.getElementById("selectCliente"))
      .value;
    this.clientePesquisado = parseInt(value);
    if (parseInt(value) == 0) {
      this.openSnackBarError("Nenhum Cliente selecionado !");
      return null;
    }
    this.getCaixas(parseInt(value));
  }

  getCaixas(idCliente: number) {
    this.loading = true;
    this.caixaService.getCaixasIdCliente(idCliente).subscribe(
      (data) => {
        this.loading = false;
        if (data.length !== 0) {
          this.inputPesquisa = true;
        } else {
          this.inputPesquisa = false;
          this.openSnackBarError(`Nenhuma caixa encontrada neste Cliente !`);
        }
        this.caixas = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  deleteCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja apagar esta caixa ? Obs: Isso apagará todos os itens da caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarCaixa(caixaId);
      }
    });
  }

  editCaixa(caixaId: number) {
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    this.router.navigate(["/editar-caixa", this.idCaixa]);
  }

  apagarCaixa(caixaId: number) {
    this.loading = true;
    this.caixaService.apagarCaixa(caixaId).subscribe(
      () => {
        this.loading = false;
        this.getCaixas(this.clientePesquisado);
        this.openSnackBarSuccess("Caixa excluída com sucesso !");
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Erro ao tentar excluír esta caixa !");
        console.error(err);
      }
    );
  }

  incluirIntens(id) {
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(id), "pcdoc").toString()
    );
    this.router.navigate(["/incluir-conteudo", this.idCaixa]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/pesquisa-caixa-avancada/pesquisa-caixa-avancada.component.ts